// 考培客户分级
export const trainingLvType = [
  { value: 50, label: 'A级' },
  { value: 51, label: 'B级' },
  { value: 53, label: 'C级' },
  { value: 55, label: 'D级' },
  { value: 57, label: 'E级' },
];

// 考培客户状态
export const trainingLevelType = [
  { value: 13, label: '等待处理' },
  { value: 9, label: '联系中' },
  { value: 10, label: '联系不上' },
  { value: 8, label: '意向跟进' },
  { value: 14, label: '长期跟进' },
  { value: 7, label: '已报名' },
  { value: 11, label: '放弃资源' },
  { value: 15, label: '已解约' },
];

// 日语基础
export const basicJapanese = [
  { value: 7, label: '0基础' },
  { value: 9, label: 'N1相当' },
  { value: 11, label: 'N2相当' },
  { value: 13, label: 'N3相当' },
  { value: 15, label: 'N4相当' },
  { value: 17, label: 'N5相当' }
];

// 学习动机
export const learningMotivation = [
  { value: 7, label: '留学' },
  { value: 9, label: '兴趣' },
  { value: 11, label: '工作' },
  { value: 13, label: '升学' },
];

// 推送方式
export const pushType = [
  { value: 1, label: '昆仑推送星图' },
  { value: 2, label: '星图批量从昆仑拉取' },
  { value: 3, label: '星图推送昆仑' },
  { value: 4, label: '昆仑推送星火' },
  { value: 5, label: '星火推送昆仑' },
  { value: 6, label: '星图推送星火' },
  { value: 7, label: '星火推送星图' },
];

// 推送方式
export const createType = [
  { value: 1, label: '考培自建' },
  { value: 2, label: '昆仑推送' },
  { value: 3, label: '批量同步' },
  { value: 7, label: '求职推送' },
];

// 韩语基础
export const basicKorea = [
  { value: 7, label: '零基础' },
  { value: 9, label: '1级相当' },
  { value: 11, label: '2级相当' },
  { value: 13, label: '3级相当' },
  { value: 15, label: '4级相当' },
  { value: 17, label: '5级相当' },
  { value: 19, label: '6级相当' },
];

// 韩语学习目标
export const targetKorea = [
  { value: 7, label: '零基础' },
  { value: 9, label: '1级相当' },
  { value: 11, label: '2级相当' },
  { value: 13, label: '3级相当' },
  { value: 15, label: '4级相当' },
  { value: 17, label: '5级相当' },
  { value: 19, label: '6级相当' },
];

// 其他语言
export const otherLan = [
  { value: 1, label: '英语' },
  { value: 2, label: '其他' },
];

// 意向语言
export const targetLan = [
  { value: 1, label: '日语' },
  { value: 2, label: '韩语' },
  { value: 3, label: '雅思' },
  { value: 4, label: '托福' },
  { value: 5, label: 'PTE' },
];
